import { usePathname } from 'next/navigation';

export default function useIsCalmSleepApp(): boolean {
	const pathname = usePathname();
	return pathname?.startsWith('/calm-sleep-app') ?? false;
}
